import React, { ReactElement } from 'react';
import oauthLogoGithubSrc from '../assets/oauth-logo-github.svg';
import { ButtonProps } from './Common';
import OauthButton from './OauthButton';
import { ButtonStyleProps } from './SharedStyles';

type styledButtonProps = ButtonProps & ButtonStyleProps;
const GithubButton = (props: styledButtonProps): ReactElement => {
  return <OauthButton {...props} iconSrc={oauthLogoGithubSrc} />;
};

export default GithubButton;
